import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { BetBuilderConfig } from '@frontend/sports/common/client-config-data-access';

@Component({
    selector: 'ms-bet-builder-custom-message',
    templateUrl: './betbuilder-custom-message.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf],
})
export class BetBuilderCustomMessageComponent implements OnInit {
    @Input() event: EventModel;

    customMessage = '';

    constructor(private betBuilderConfig: BetBuilderConfig) {}

    ngOnInit(): void {
        const messages = this.betBuilderConfig.customMessages[this.event.sport.id];

        if (!messages) {
            return;
        }

        this.customMessage =
            messages.find((message) => message.key === this.event.league.id.toString())?.message ||
            messages.find((message) => message.key?.toLowerCase() === 'default')?.message ||
            '';
    }
}
